module.exports = __webpack_public_path__ + "assets/camp_list_children_image.96f2732c0223dd3a90107e487b1b183f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/camp/camp_list_children_image.png
// module id = 756
// module chunks = 0